export default __webpack_public_path__ + "static/media/Lori_Armstrong.6afd1c62.png";